import React from "react";
import { Box, Grid, useTheme } from "@mui/material";
import Header from "../../components/VersatileComponents/Header";
import UserCard from "../../components/User/card/sub_admin/sub_admin";
import { Helmet } from "react-helmet-async";
import useCollectionData from "../../hooks/useCollectionData";
const SubAdmin = () => {
  const theme = useTheme();
  const { data: subAdmins } = useCollectionData("subAdmin");

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>SubAdmin</title>

        <meta name="description" content="List of SubAdmins" />
      </Helmet>
      <Box
        m="1.5rem 2.5rem"
        sx={{
          backgroundColor: theme.palette.background.default,
          height: "100vh",
          position: "relative",
        }}
      >
        <Header title="SubAdmin" subtitle="Entire list of SubAdmins" />
        <Grid container spacing={2}>
          {subAdmins?.map((item) => (
            <Grid key={item.id} item xs={6} sm={4} md={4} lg={4} xl={4}>
              <UserCard userInfo={item} userType={"subAdmin"} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default SubAdmin;
